import uuid from "uuid/v4";
import isEqual from "lodash/isEqual";
import cloneDeep from "lodash/cloneDeep";
import TopicPermissions from "@/permissions/TopicPermissions";
import TopicStatus from "@/constants/TopicStatus";
import TopicOccurrenceType from "@/constants/TopicOccurrenceType";
import MeetingPermissions from "@/permissions/MeetingPermissions";
import NOID from "@/constants/NOID";

const isTopicDirty = ( currentTopic, pristineTopic ) => {
	return !isEqual( currentTopic, pristineTopic );
};

export const createNewTopic = ( meetingId, userProfile ) => {
	const {
		email,
		name,
		picture,
		preferredName,
		title,
		location,
		bio,
	} = userProfile;

	const creator = {
		email,
		name,
		picture,
		personId: userProfile.personId,
		preferredName,
		title,
		location,
		bio,
		assessments: {},
		isRegisteredUser: true,
	};

	return {
		uiKey: uuid(),
		id: "",
		meetingId,
		title: "",
		status: "PLANNED",
		creator,
		duration: 0,
		created: null,
		description: "",
		outcomes: [],
	};
};

export const create = ( { meeting, userProfile, timezone, } ) => {
	const meetingPermissions = new MeetingPermissions( {
		meeting,
		timezone,
		userProfile,
	} );

	return {
		createNewTopic,
		createPermissions( topic ) {
			const topicPermissions = new TopicPermissions( {
				topic,
				timezone,
				userProfile,
				meetingPermissions,
			} );

			return topicPermissions.resolve();
		},
		createField( pristineTopic, currentTopic = null ) {
			if ( !currentTopic ) {
				currentTopic = cloneDeep( pristineTopic );
			}
			const pristinePermissionedTopic = {
				...pristineTopic,
				permissions: this.createPermissions( pristineTopic ),
			};

			const currentPermissionedTopic = {
				...currentTopic,
				permissions: this.createPermissions( currentTopic ),
			};

			return {
				uiKey: uuid(),
				pristineTopic: pristinePermissionedTopic,
				currentTopic: currentPermissionedTopic,
				isNew: currentTopic.id === NOID,
				isDirty: isTopicDirty( currentTopic, pristineTopic ),
				isSelected: false,
				isActive: false,
				isValid: true, // TODO: validation
				isPlanned: currentTopic.status !== TopicStatus.DEFERRED,
				isDeferred: currentTopic.status === TopicStatus.DEFERRED,
				isOneOff: currentTopic.occurenceType === TopicOccurrenceType.ONE_OFF,
				isPinned: currentTopic.occurenceType === TopicOccurrenceType.PINNED,
				isPinnedInstance: currentTopic.occurenceType === TopicOccurrenceType.PINNED_INSTANCE,
			};
		},
	};
};



// WEBPACK FOOTER //
// ./src/store/modules/topicHelpers.js